import React from 'react';
import AisinoRow from "./baseComponent/rowAndCol/AisinoRow";
import AisinoCol from "./baseComponent/rowAndCol/AisinoCol";
import {formLayout} from "./constant/css";
import {getCurrentCurrency, getLanguage, validateMessages,numberFormatNew} from "./source/js/common";
import AisinoForm from "./baseComponent/form/AisinoForm";
import FormItemDictSelect from "./common/form/select/FormItemDictSelect";
import saleQtyImg from "file-loader!./source/images/mypro/home_tub1_icon.png";
import saleAmountImg from "file-loader!./source/images/mypro/home_tub2_icon.png";
import titleImg from "file-loader!./source/images/mypro/home_title1_img.png";
import AisinoFormItem from "./baseComponent/form/AisinoFormItem";
import AisinoSelect from "./baseComponent/form/select/AisinoSelect";
import {post, postSync} from "./common/utils/http";
import ReactEchartsCore from "echarts-for-react/lib/core";
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legend';
import moment from 'moment';
import {ConfirmStatus, DocumentStatus} from "./dictionary";
import cookie from "react-cookies";
import {isEmpty} from "./common/utils/StringUtils";

export const colLayout = {xs: 23, sm: 23, md: 22, lg: 22 };

//formItem样式
export const formItemColLayout = {xs: 18, sm: 16, md: 14, lg: 12 };
export const formItemTailLayout = {
    wrapperCol: {
        xs: 18,
        sm: 18,
        md: 18,
        lg: 18
    }
};

const homeLan = require('./constant/js/formItemNameLabel/'+getLanguage()+'/home.js');

function formatNum(strNum) {
    if (strNum.length <= 3) {
        return strNum
    }
    if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(strNum)) {
        return strNum
    }
    let a = RegExp.$1

    let b = RegExp.$2

    let c = RegExp.$3
    let re = new RegExp()
    re.compile('(\\d)(\\d{3})(,|$)');
    while (re.test(b)) {
        b = b.replace(re, '$1,$2$3')
    }
    return a + '' + b + '' + c
}

class Home extends React.Component {
    constructor(props){
        super(props);
        this.state={
            echartsOption:{},
            salesInvoice:{
                amount:"0",
                invoicevalid:"0",
                awaiting:"0",
                accepted:"0",
                rejected:"0"
            },
            drawerVisible:true
        }
        this.formRef=React.createRef();
    }
    componentDidMount() {
        const that = this;
        that.statisticsSelect('1');
        that.getSalesInvoiceStatistics(that.getCurrentMonth());

        setInterval(function(){
            that.reloadCookie();
        }, 30000);

    }
    async reloadCookie(){
        if(isEmpty(cookie.load("gridPageSizeParam")) || isEmpty(cookie.load("gridSizeListParam"))){
            const sysParams = await post("aisino/portalIndex/sysParam");
            if(sysParams){
                cookie.save("gridPageSizeParam",sysParams.gridPageSizeParam);
                cookie.save("gridSizeListParam",sysParams.gridSizeListParam);
            }
        }
    }

    getCurrentMonth(){
        return  moment().month() + 1+"";
    }

    getSalesInvoiceStatistics(month){
        postSync('aisino/portalIndex/getSalesDataByMonth',{month:month}).then(res=>{
            this.setState({
                salesInvoice:res
            })
        })
    }

    statisticsSelect(value){
        const that = this;
        if (value === '1') {
            that.requestStatistics().then(res=>{
                that.getPieOption(res, that);
            })
        } else {
            that.requestTaxStatistics().then(res=>{
                that.getBarOption(res, that);
            })
        }
    }
    requestStatistics() {
        return postSync('aisino/portalIndex/getInvoiceStatistics')
    }
    requestTaxStatistics() {
        return postSync('aisino/portalIndex/getTaxStatistics')
    }
    getPieOption(response, that) {
        let outData = [];
        let innerData = [];
        response.forEach(item => {
            outData.push({ name: item.name, value: item.value });
            innerData.push({ name: item.name, value: item.quantity });
        });
        let options = {
            tooltip: {
                trigger: 'item',
                formatter: function (p) {
                    let top_title = homeLan.no;
                    if (getCurrentCurrency()+": " == p.seriesName) {
                        top_title = homeLan.value;
                    }
                    let str = '&nbsp;&nbsp;&nbsp;<span style="text-align: center;text-decoration: underline">' + top_title + '</span><br/>' + p.name + '<br/>' + p.seriesName + formatNum(p.value)
                    return str
                }
            },
            legend: {
                orient: 'vertical',
                left: 10,
                tooltip: {
                    show: false,

                },
                data: [homeLan.yearly, homeLan.monthly, homeLan.weekly, homeLan.daily]
            },
            series: [
                {
                    name: getCurrentCurrency()+': ',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    minAngle: 2,
                    label: {
                        normal: {
                            show: false,
                            fontSize: 20,
                            position: 'outside'
                        },
                        emphasis: {
                            show: true,
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false,
                            length: 10
                        }
                    },
                    data: outData,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        },
                        normal: {
                            color: function (params) {
                                //自定义颜色
                                let colorList = [
                                    '#0070C0', '#4BACC6', '#B7DDE8', '#FFE100'
                                ];
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                }, {
                    name: 'No. ',
                    type: 'pie',
                    selectedMode: 'single',
                    legendHoverLink:false,
                    radius: [0, '30%'],
                    minAngle: 2,
                    label: {
                        normal: {
                            show: false,
                            fontSize: 20,
                            position: 'outside'
                        },
                        emphasis: {
                            show: true,
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false,
                            length: 40
                        }
                    },
                    data: innerData,
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        },
                        normal: {
                            color: function (params) {
                                //自定义颜色
                                let colorList = [
                                    '#0070C0', '#4BACC6', '#B7DDE8', '#FFE100'
                                ];
                                return colorList[params.dataIndex]
                            }
                        }
                    }
                }
            ]
        };
        that.state.echartsOption = options;
        that.forceUpdate();
    }
    getBarOption(response, that) {
        let arr = ['total','salesTax','serviceTax','tourismTax','highValueTax','lowValueTax','nonTax','taxExemption'];
        let newData={};
        for(let i=0;i<arr.length;i++){
            newData[arr[i]]=[response["daily"][i]['amount'],response["weekly"][i]['amount'],response["monthly"][i]['amount'],response["yearly"][i]['amount']];
        }
        let options = {
            tooltip: {
                trigger: 'axis',
                formatter: function (p) {
                    let str = p[0].name+'<br/>';
                    for (let i = 0; i < p.length; i++) {
                        let split = ' ';
                        // if (i % 2 == 0) {
                        //     split = split + '-'
                        // }
                        // for (let j = 0; j < 9 - p[i].seriesName.length; j++) {
                        //     split = split + '-'
                        // }
                        str = str + p[i].marker + p[i].seriesName + split + getCurrentCurrency()+":" + formatNum(p[i].value) + '<br/>';
                    }
                    return '<div style="text-align:left">'+str+'</div>'
                },
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: ['total','salesTax','serviceTax','tourismTax','highValueTax','lowValueTax','nonTax','taxExemption']
            },
            color: ['#929fff', '#9de0ff', '#ffa897', '#af87fe','#7dc3fe','#bb60b2','#433e7c','#f47a75'],
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: [homeLan.daily, homeLan.weekly, homeLan.monthly, homeLan.yearly]
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: 'Total Tax',
                    type: 'bar',
                    data: newData['total']
                },
                {
                    name: 'Sales Tax',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['salesTax']
                },
                {
                    name: 'Service Tax',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['serviceTax']
                },
                {
                    name: 'Tourism Tax',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['tourismTax']
                },
                {
                    name: 'High-Value Goods Tax',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['highValueTax']
                },
                {
                    name: 'Sales Tax on Low Value Goods',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['lowValueTax']
                },
                {
                    name: 'Not Applicable',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['nonTax']
                },
                {
                    name: 'Tax exemption (where applicable)',
                    type: 'bar',
                    stack: 'Total',
                    data: newData['taxExemption']
                }
            ]
        };
        that.state.echartsOption = options;
        that.forceUpdate();
    }
    salesDataClick(){
        let params= this.getStartEndDateByMonth();
        params["invoiceStatus"] = DocumentStatus.VALID;
        this.props.history.push({pathname:"/invoice",state:{data:params}});
    }
    salesStatusClick(status){
        let params= this.getStartEndDateByMonth();
        params["confirmStatusCode"]=status;
        params["invoiceStatus"] = DocumentStatus.VALID;
        this.props.history.push({pathname:"/invoice",state:{data:params}});
    }
    getStartEndDateByMonth(){
        let salesMonth= parseInt(this.formRef.current.getFieldValue("salesMonth"));
        const startDate = moment().set({ 'month': salesMonth - 1, 'date': 1 });
        const endDate = moment(startDate).endOf('month');
        return {issuedDateFrom:startDate,issuedDateTo:endDate};
    }
    render() {
        const {salesInvoice,drawerVisible}=this.state;
        return(
            <AisinoForm {...formLayout} validateMessages={validateMessages()}
                        ref={this.formRef} >
                <AisinoRow justify="center">
                    <AisinoCol {...colLayout}>
                        <AisinoRow style={{border: "1px solid #dddddd"}}>
                            <AisinoCol span={24}>
                                <AisinoRow style={{paddingTop:"10px"}}>
                                    <AisinoCol span={12} push={1} style={{fontSize: "20px",fontWeight: "700",textAlign: "left"}}>
                                        <span>{homeLan.salesInvoices}</span>
                                    </AisinoCol>
                                    <AisinoCol span={12}>
                                        <AisinoRow justify="end">
                                            <AisinoCol {...formItemColLayout}>
                                                <FormItemDictSelect {...formItemTailLayout} typecode={"monthsCode"} name={"salesMonth"} initialValue={this.getCurrentMonth()} onChange={(value) => this.getSalesInvoiceStatistics(value)}/>
                                            </AisinoCol>
                                        </AisinoRow>
                                    </AisinoCol>
                                </AisinoRow>
                                <AisinoRow justify="space-around" style={{paddingTop:"30px"}}>
                                    <AisinoCol span={8} >
                                        <div style={{position: "relative",background: "#fef8f4",border: "1px solid #fbf2eb",borderRadius: "6px",textAlign: "center"}}>
                                            <div style={{position: "absolute", top: "-16px", left: "15px", width: "40px", height: "40px"}}>
                                                <img  src={saleQtyImg}></img>
                                            </div>
                                            <p style={{margin: "20px 0 6px 0",fontSize: "26px",fontWeight: "700"}}>
                                                <a onClick={()=>this.salesDataClick()}>{numberFormatNew(salesInvoice.invoicevalid+"")}</a>
                                            </p>
                                            <span style={{fontSize: "16px",fontWeight: "400",color: "#666666"}}>{homeLan.totalInvoiceQuantity}</span>
                                        </div>
                                    </AisinoCol>
                                    <AisinoCol span={8}>
                                        <div style={{position: "relative",background: "#fef8f4",border: "1px solid #fbf2eb",borderRadius: "6px",textAlign: "center"}}>
                                            <div style={{position: "absolute", top: "-16px", left: "15px", width: "40px", height: "40px"}}>
                                                <img  src={saleAmountImg}></img>
                                            </div>
                                            <p style={{margin: "20px 0 6px 0",fontSize: "26px",fontWeight: "700"}}>
                                                <a onClick={()=>this.salesDataClick()}>{numberFormatNew(salesInvoice.amount+"")}</a>
                                            </p>
                                            <span style={{fontSize: "16px",fontWeight: "400",color: "#666666"}}>{homeLan.totalInvoiceAmount}</span>
                                        </div>
                                    </AisinoCol>
                                </AisinoRow>
                                <AisinoRow justify="space-around" style={{paddingTop:"30px",paddingBottom:"20px"}}>
                                    <AisinoCol span={6}>
                                        <div style={{textAlign: "center"}}>
                                            <p style={{marginBottom: "6px",fontSize: "26px",fontWeight: "700"}}>
                                                <a onClick={()=>this.salesStatusClick(ConfirmStatus.AWAITING)}>{numberFormatNew(salesInvoice.awaiting+"")}</a>
                                            </p>
                                        </div>
                                        <div style={{margin: "0 auto", background:" url("+titleImg+")",backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",fontWeight: "bold",textAlign: "center",height:"30px"}}>{homeLan.awaiting}</div>
                                    </AisinoCol>
                                    <AisinoCol span={6}>
                                        <div style={{textAlign: "center"}}>
                                            <p style={{marginBottom: "6px",fontSize: "26px",fontWeight: "700"}}>
                                                <a onClick={()=>this.salesStatusClick(ConfirmStatus.APPROVED)}>{numberFormatNew(salesInvoice.accepted+"")}</a>
                                            </p>
                                        </div>
                                        <div style={{margin: "0 auto", background:" url("+titleImg+")",backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",fontWeight: "bold",textAlign: "center",height:"30px"}}>{homeLan.accepted}</div>
                                    </AisinoCol>
                                    <AisinoCol span={6}>
                                        <div style={{textAlign: "center"}}>
                                            <p style={{marginBottom: "6px",fontSize: "26px",fontWeight: "700"}}>
                                                <a onClick={()=>this.salesStatusClick(ConfirmStatus.REJECTED)}>{numberFormatNew(salesInvoice.rejected+"")}</a>
                                            </p>
                                        </div>
                                        <div style={{margin: "0 auto", background:" url("+titleImg+")",backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",fontWeight: "bold",textAlign: "center",height:"30px"}}>{homeLan.rejected}</div>
                                    </AisinoCol>
                                </AisinoRow>
                            </AisinoCol>
                        </AisinoRow>
                        <AisinoRow style={{border: "1px solid #dddddd"}}>
                            <AisinoCol span={24}>
                                <AisinoRow justify="center" style={{marginTop:"10px"}}>
                                    <AisinoCol span={12} push={1} style={{fontSize: "20px",fontWeight: "700",textAlign: "left"}}>
                                        <span>{homeLan.statisticsType}</span>
                                    </AisinoCol>
                                    <AisinoCol span={12}>
                                        <AisinoRow justify="end">
                                            <AisinoCol {...formItemColLayout}>
                                                <AisinoFormItem {...formItemTailLayout}  label={""} name={"statisticsType"} initialValue={"1"} >
                                                    <AisinoSelect  allowClear={false}  onChange={(value) => this.statisticsSelect(value)} options={[{value:'1',label:'Receipts/Invoices Issued'},{value:'3',label:'Tax statistics'}]}/>
                                                </AisinoFormItem>
                                            </AisinoCol>
                                        </AisinoRow>
                                    </AisinoCol>
                                </AisinoRow>
                                <AisinoRow justify="center">
                                    <AisinoCol span={16}>
                                        <div id="main" style={{ width: "100%", height: "300px" }}>
                                            <ReactEchartsCore
                                                echarts={echarts}
                                                option={this.state.echartsOption}
                                                notMerge={true}
                                                lazyUpdate={true}
                                                theme={"theme_name"}
                                                //onChartReady={this.onChartReadyCallback}
                                                //onEvents={echartsClick}
                                                opts={{}}
                                            />
                                        </div>
                                    </AisinoCol>
                                </AisinoRow>
                            </AisinoCol>
                        </AisinoRow>
                    </AisinoCol>
                </AisinoRow>
            </AisinoForm>
        )
    }
}
export default Home;
